// import React, { useEffect, useMemo, useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemText,
//   Avatar,
//   Menu,
//   MenuItem,
//   useMediaQuery,
//   Badge,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
// import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
// import { useTheme } from "@mui/material/styles";
// import { useLocation, useNavigate } from "react-router-dom";
// import ApiServices from "../Utils/ApiServices";

// const DEFAULT_ROUTES = {
//   guest: [
//     { label: "Home", path: "/" },
//     { label: "Menu", path: "/menu" },
//     { label: "About", path: "/about" },
//     { label: "Contact", path: "/contact" },
//     { label: "Login", path: "/login" },
//     { label: "Sign Up", path: "/signup" },
//     { label: "Cart", path: "/cart", icon: "cart" },
//   ],
//   loggedIn: [
//     { label: "Home", path: "/" },
//     { label: "Menu", path: "/menu" },
//     { label: "About", path: "/about" },
//     { label: "Contact", path: "/contact" },
//     { label: "Cart", path: "/cart", icon: "cart" },
//   ],
// };

// const getAccessToken = () => localStorage.getItem("access_token") || "";

// const getCustomerId = () =>
//   localStorage.getItem("customer_id") ||
//   localStorage.getItem("customerId") ||
//   localStorage.getItem("logged_customer_id") ||
//   localStorage.getItem("user_id") ||
//   "";

// const WebNavbar = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);

//   const [isLogged, setIsLogged] = useState(
//     localStorage.getItem("is_logged") === "true"
//   );

//   const [cartItemCount, setCartItemCount] = useState(
//     Number(localStorage.getItem("cart_item_count") || 0)
//   );

//   const config = {
//     restaurantName: "Pizza Town",
//     primaryColor: "#b71c1c",
//     textColor: "#ffffff",
//     activeColor: "rgba(255,255,255,0.18)",
//     hoverColor: "rgba(255,255,255,0.10)",
//     mobileTextColor: "#222",
//   };

//   const fetchCartCount = async () => {
//     const logged = localStorage.getItem("is_logged") === "true";
//     const customerId = getCustomerId();
//     const token = getAccessToken();

//     if (!logged || !customerId || !token) {
//       setCartItemCount(0);
//       localStorage.setItem("cart_item_count", "0");
//       return;
//     }

//     try {
//       const response = await ApiServices.get(
//         `/api/v1/customers/${customerId}/cart/`,
//         {
//           Authorization: `Bearer ${token}`,
//         }
//       );

//       const count =
//         response?.data?.items?.reduce(
//           (acc, item) => acc + Number(item.quantity || 0),
//           0
//         ) || 0;

//       setCartItemCount(count);
//       localStorage.setItem("cart_item_count", String(count));
//     } catch (error) {
//       setCartItemCount(0);
//       localStorage.setItem("cart_item_count", "0");
//     }
//   };

//   useEffect(() => {
//     const syncLogin = () => {
//       const logged = localStorage.getItem("is_logged") === "true";
//       setIsLogged(logged);
//       fetchCartCount();
//     };

//     window.addEventListener("storage", syncLogin);
//     window.addEventListener("login-state-updated", syncLogin);

//     return () => {
//       window.removeEventListener("storage", syncLogin);
//       window.removeEventListener("login-state-updated", syncLogin);
//     };
//   }, []);

//   useEffect(() => {
//     fetchCartCount();
//   }, [location.pathname, isLogged]);

//   useEffect(() => {
//     const handleCartCountUpdated = (event) => {
//       const count = Number(event?.detail?.count || 0);
//       setCartItemCount(count);
//       localStorage.setItem("cart_item_count", String(count));
//     };

//     window.addEventListener("cart-count-updated", handleCartCountUpdated);

//     return () => {
//       window.removeEventListener("cart-count-updated", handleCartCountUpdated);
//     };
//   }, []);

//   const routes = useMemo(() => {
//     return isLogged ? DEFAULT_ROUTES.loggedIn : DEFAULT_ROUTES.guest;
//   }, [isLogged]);

//   const handleNavigation = (path) => {
//     navigate(path);
//     setMobileOpen(false);
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     setIsLogged(false);
//     setCartItemCount(0);
//     window.dispatchEvent(
//       new CustomEvent("cart-count-updated", { detail: { count: 0 } })
//     );
//     navigate("/login");
//   };

//   const renderRouteIcon = (icon) => {
//     if (icon === "cart") {
//       return (
//         <Badge
//           badgeContent={cartItemCount}
//           color="warning"
//           showZero={false}
//           overlap="circular"
//         >
//           <ShoppingCartOutlinedIcon sx={{ fontSize: 20 }} />
//         </Badge>
//       );
//     }

//     if (icon === "profile") {
//       return <AccountCircleOutlinedIcon sx={{ fontSize: 20 }} />;
//     }

//     return null;
//   };

//   const renderDesktopRoutes = () =>
//     routes.map((route) => {
//       const isActive = location.pathname === route.path;

//       return (
//         <Button
//           key={route.path}
//           onClick={() => handleNavigation(route.path)}
//           startIcon={renderRouteIcon(route.icon)}
//           sx={{
//             color: config.textColor,
//             textTransform: "none",
//             borderRadius: "10px",
//             px: 2,
//             py: 1,
//             fontWeight: isActive ? 700 : 500,
//             backgroundColor: isActive ? config.activeColor : "transparent",
//             "&:hover": {
//               backgroundColor: config.hoverColor,
//             },
//           }}
//         >
//           {route.icon === "cart" && cartItemCount > 0
//             ? `${route.label} (${cartItemCount})`
//             : route.label}
//         </Button>
//       );
//     });

//   return (
//     <>
//       <AppBar position="static" sx={{ backgroundColor: config.primaryColor }}>
//         <Toolbar sx={{ justifyContent: "space-between" }}>
//           <Box display="flex" alignItems="center" gap={1}>
//             <RestaurantMenuIcon sx={{ color: config.textColor }} />
//             <Typography color={config.textColor} fontWeight={700}>
//               {config.restaurantName}
//             </Typography>
//           </Box>

//           {!isMobile && (
//             <Box display="flex" alignItems="center" gap={1}>
//               {renderDesktopRoutes()}

//               {isLogged && (
//                 <>
//                   <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
//                     <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)" }}>
//                       P
//                     </Avatar>
//                   </IconButton>

//                   <Menu
//                     anchorEl={anchorEl}
//                     open={Boolean(anchorEl)}
//                     onClose={() => setAnchorEl(null)}
//                   >
//                     <MenuItem
//                       onClick={() => handleNavigation("/customer/profile")}
//                     >
//                       My Profile
//                     </MenuItem>

//                     <MenuItem onClick={() => handleNavigation("/orders")}>
//                       My Orders
//                     </MenuItem>

//                     <MenuItem onClick={handleLogout}>Logout</MenuItem>
//                   </Menu>
//                 </>
//               )}
//             </Box>
//           )}

//           {isMobile && (
//             <IconButton onClick={() => setMobileOpen(true)}>
//               <Badge
//                 badgeContent={cartItemCount}
//                 color="warning"
//                 showZero={false}
//               >
//                 <MenuIcon sx={{ color: config.textColor }} />
//               </Badge>
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={() => setMobileOpen(false)}
//       >
//         <Box p={2} width={260}>
//           <Typography fontWeight={700} mb={2}>
//             {config.restaurantName}
//           </Typography>

//           <List>
//             {routes.map((route) => (
//               <ListItemButton
//                 key={route.path}
//                 onClick={() => handleNavigation(route.path)}
//                 selected={location.pathname === route.path}
//               >
//                 <Box display="flex" alignItems="center" gap={1} width="100%">
//                   {route.icon === "cart" ? (
//                     <Badge
//                       badgeContent={cartItemCount}
//                       color="warning"
//                       showZero={false}
//                     >
//                       <ShoppingCartOutlinedIcon sx={{ fontSize: 20 }} />
//                     </Badge>
//                   ) : null}

//                   <ListItemText
//                     primary={
//                       route.icon === "cart" && cartItemCount > 0
//                         ? `${route.label} (${cartItemCount})`
//                         : route.label
//                     }
//                   />
//                 </Box>
//               </ListItemButton>
//             ))}

//             {isLogged && (
//               <>
//                 <ListItemButton
//                   onClick={() => handleNavigation("/customer/profile")}
//                 >
//                   <ListItemText primary="My Profile" />
//                 </ListItemButton>

//                 <ListItemButton onClick={() => handleNavigation("/orders")}>
//                   <ListItemText primary="My Orders" />
//                 </ListItemButton>

//                 <ListItemButton onClick={handleLogout}>
//                   <ListItemText primary="Logout" />
//                 </ListItemButton>
//               </>
//             )}
//           </List>
//         </Box>
//       </Drawer>
//     </>
//   );
// };

// export default WebNavbar;



// src/components/WebNavbar.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery,
  Badge,
  Divider,
  ListItemIcon,
  Chip,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import ApiServices from "../Utils/ApiServices";

const brand = {
  redDeep: "#7A0E0E",
  red: "#B71C1C",
  orange: "#E64A19",
  amber: "#FFB300",
  cream: "#FFF8F0",
  charcoal: "#2A1810",
  gradientPrimary:
    "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)",
  gradientAmber:
    "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)",
};

const DEFAULT_ROUTES = {
  guest: [
    { label: "Home", path: "/" },
    { label: "Menu", path: "/menu" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
    { label: "Login", path: "/login" },
    { label: "Sign Up", path: "/signup" },
    { label: "Cart", path: "/cart", icon: "cart" },
  ],
  loggedIn: [
    { label: "Home", path: "/" },
    { label: "Menu", path: "/menu" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
    { label: "Cart", path: "/cart", icon: "cart" },
  ],
};

const ROUTE_ICON_MAP = {
  Home: <HomeRoundedIcon fontSize="small" />,
  Menu: <RestaurantRoundedIcon fontSize="small" />,
  About: <InfoRoundedIcon fontSize="small" />,
  Contact: <MailOutlineRoundedIcon fontSize="small" />,
  Login: <LoginRoundedIcon fontSize="small" />,
  "Sign Up": <PersonAddAlt1RoundedIcon fontSize="small" />,
  Cart: <ShoppingCartOutlinedIcon fontSize="small" />,
};

const getAccessToken = () => localStorage.getItem("access_token") || "";

const getCustomerId = () =>
  localStorage.getItem("customer_id") ||
  localStorage.getItem("customerId") ||
  localStorage.getItem("logged_customer_id") ||
  localStorage.getItem("user_id") ||
  "";

const MotionButton = motion(Button);

const WebNavbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const [isLogged, setIsLogged] = useState(
    localStorage.getItem("is_logged") === "true"
  );

  const [cartItemCount, setCartItemCount] = useState(
    Number(localStorage.getItem("cart_item_count") || 0)
  );

  const config = {
    restaurantName: "Pizza Town",
    tagline: "Authentic • Fresh • Fast",
  };

  const fetchCartCount = async () => {
    const logged = localStorage.getItem("is_logged") === "true";
    const customerId = getCustomerId();
    const token = getAccessToken();

    if (!logged || !customerId || !token) {
      setCartItemCount(0);
      localStorage.setItem("cart_item_count", "0");
      return;
    }

    try {
      const response = await ApiServices.get(
        `/api/v1/customers/${customerId}/cart/`,
        { Authorization: `Bearer ${token}` }
      );

      const count =
        response?.data?.items?.reduce(
          (acc, item) => acc + Number(item.quantity || 0),
          0
        ) || 0;

      setCartItemCount(count);
      localStorage.setItem("cart_item_count", String(count));
    } catch (error) {
      setCartItemCount(0);
      localStorage.setItem("cart_item_count", "0");
    }
  };

  useEffect(() => {
    const syncLogin = () => {
      const logged = localStorage.getItem("is_logged") === "true";
      setIsLogged(logged);
      fetchCartCount();
    };

    window.addEventListener("storage", syncLogin);
    window.addEventListener("login-state-updated", syncLogin);

    return () => {
      window.removeEventListener("storage", syncLogin);
      window.removeEventListener("login-state-updated", syncLogin);
    };
  }, []);

  useEffect(() => {
    fetchCartCount();
  }, [location.pathname, isLogged]);

  useEffect(() => {
    const handleCartCountUpdated = (event) => {
      const count = Number(event?.detail?.count || 0);
      setCartItemCount(count);
      localStorage.setItem("cart_item_count", String(count));
    };

    window.addEventListener("cart-count-updated", handleCartCountUpdated);
    return () => {
      window.removeEventListener("cart-count-updated", handleCartCountUpdated);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const routes = useMemo(
    () => (isLogged ? DEFAULT_ROUTES.loggedIn : DEFAULT_ROUTES.guest),
    [isLogged]
  );

  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false);
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLogged(false);
    setCartItemCount(0);
    window.dispatchEvent(
      new CustomEvent("cart-count-updated", { detail: { count: 0 } })
    );
    navigate("/login");
    setAnchorEl(null);
    setMobileOpen(false);
  };

  const renderDesktopRoutes = () => {
    return routes.map((route) => {
      const isActive = location.pathname === route.path;
      const isCart = route.icon === "cart";

      if (isCart) {
        return (
          <motion.div
            key={route.path}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.96 }}
          >
            <Button
              onClick={() => handleNavigation(route.path)}
              startIcon={
                <motion.span
                  key={cartItemCount}
                  initial={{ scale: 0.6, rotate: -10 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ type: "spring", stiffness: 500, damping: 14 }}
                  style={{ display: "inline-flex" }}
                >
                  <Badge
                    badgeContent={cartItemCount}
                    showZero={false}
                    overlap="circular"
                    sx={{
                      "& .MuiBadge-badge": {
                        bgcolor: "#fff",
                        color: brand.redDeep,
                        fontWeight: 800,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      },
                    }}
                  >
                    <ShoppingCartOutlinedIcon sx={{ fontSize: 20 }} />
                  </Badge>
                </motion.span>
              }
              sx={{
                color: brand.charcoal,
                background: brand.gradientAmber,
                px: 2.4,
                py: 1,
                fontWeight: 700,
                borderRadius: 999,
                textTransform: "none",
                boxShadow:
                  "0 8px 20px rgba(255,179,0,0.45), inset 0 1px 0 rgba(255,255,255,0.6)",
                "&:hover": {
                  background: brand.gradientAmber,
                  boxShadow: "0 12px 26px rgba(255,179,0,0.6)",
                },
              }}
            >
              {cartItemCount > 0 ? `Cart · ${cartItemCount}` : "Cart"}
            </Button>
          </motion.div>
        );
      }

      return (
        <Box key={route.path} sx={{ position: "relative" }}>
          <MotionButton
            onClick={() => handleNavigation(route.path)}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.96 }}
            sx={{
              color: "#fff",
              textTransform: "none",
              borderRadius: 999,
              px: 2,
              py: 1,
              fontWeight: isActive ? 700 : 500,
              letterSpacing: 0.2,
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.08)",
                boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
              },
            }}
          >
            {route.label}
          </MotionButton>
          {isActive && (
            <motion.div
              layoutId="active-nav-pill"
              transition={{ type: "spring", stiffness: 380, damping: 30 }}
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: 999,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))",
                border: "1px solid rgba(255,255,255,0.25)",
                pointerEvents: "none",
              }}
            />
          )}
          {isActive && (
            <motion.div
              layoutId="active-nav-underline"
              style={{
                position: "absolute",
                left: "20%",
                right: "20%",
                bottom: -6,
                height: 3,
                borderRadius: 3,
                background: brand.gradientAmber,
                boxShadow: "0 0 14px rgba(255,179,0,0.8)",
              }}
            />
          )}
        </Box>
      );
    });
  };

  const Brand = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={() => handleNavigation("/")}
    >
      <motion.div
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        whileHover={{ rotate: -8, scale: 1.12 }}
        style={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          background: brand.gradientAmber,
          boxShadow:
            "0 0 0 2px rgba(255,255,255,0.35), 0 8px 24px rgba(255,179,0,0.55), inset 0 1px 0 rgba(255,255,255,0.6)",
        }}
      >
        <RestaurantMenuIcon sx={{ color: brand.redDeep, fontSize: 24 }} />
      </motion.div>
      <Box sx={{ lineHeight: 1 }}>
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "'Playfair Display', serif",
            fontWeight: 800,
            fontSize: { xs: 20, md: 24 },
            letterSpacing: 0.4,
            textShadow: "0 2px 10px rgba(0,0,0,0.25)",
          }}
        >
          {config.restaurantName}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.78)",
            fontSize: 11,
            letterSpacing: 2,
            textTransform: "uppercase",
            mt: 0.3,
            display: { xs: "none", sm: "block" },
          }}
        >
          {config.tagline}
        </Typography>
      </Box>
    </Box>
  );

  const drawerContent = (
    <Box
      role="presentation"
      sx={{
        width: { xs: "88vw", sm: 320 },
        height: "100%",
        background:
          "linear-gradient(180deg, #FFF8F0 0%, #FFEFE0 60%, #FFE4CC 100%)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          p: 2.5,
          background: brand.gradientPrimary,
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(400px 200px at 100% 0%, rgba(255,179,0,0.35), transparent 60%)",
            pointerEvents: "none",
          }}
        />
        <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              background: brand.gradientAmber,
              boxShadow: "0 8px 22px rgba(0,0,0,0.25)",
            }}
          >
            <RestaurantMenuIcon sx={{ color: brand.redDeep }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontFamily: "'Playfair Display', serif", fontWeight: 800, fontSize: 22 }}>
              {config.restaurantName}
            </Typography>
            <Typography sx={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", opacity: 0.85 }}>
              {config.tagline}
            </Typography>
          </Box>
          <IconButton
            onClick={() => setMobileOpen(false)}
            sx={{
              color: "#fff",
              bgcolor: "rgba(255,255,255,0.12)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.22)" },
            }}
            aria-label="Close menu"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", px: 1.5, py: 2 }}>
        <AnimatePresence>
          {mobileOpen &&
            routes.map((route, i) => {
              const isActive = location.pathname === route.path;
              const isCart = route.icon === "cart";
              return (
                <motion.div
                  key={route.path}
                  initial={{ opacity: 0, x: 24 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 24 }}
                  transition={{ duration: 0.3, delay: i * 0.05 }}
                >
                  <Box
                    onClick={() => handleNavigation(route.path)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      px: 1.5,
                      py: 1.4,
                      mb: 0.8,
                      borderRadius: 2,
                      cursor: "pointer",
                      position: "relative",
                      background: isActive
                        ? "linear-gradient(90deg, rgba(255,179,0,0.18), rgba(255,179,0,0.04))"
                        : "transparent",
                      border: isActive
                        ? "1px solid rgba(255,179,0,0.4)"
                        : "1px solid transparent",
                      transition: "all .2s ease",
                      "&:hover": {
                        background: "rgba(183,28,28,0.06)",
                        transform: "translateX(2px)",
                      },
                      "&::before": isActive
                        ? {
                            content: '""',
                            position: "absolute",
                            left: -1,
                            top: 8,
                            bottom: 8,
                            width: 4,
                            borderRadius: 4,
                            background: brand.gradientAmber,
                          }
                        : {},
                    }}
                  >
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        display: "grid",
                        placeItems: "center",
                        bgcolor: isActive ? brand.amber : "rgba(183,28,28,0.08)",
                        color: isActive ? brand.redDeep : brand.red,
                      }}
                    >
                      {isCart ? (
                        <Badge
                          badgeContent={cartItemCount}
                          color="error"
                          showZero={false}
                        >
                          <ShoppingCartOutlinedIcon fontSize="small" />
                        </Badge>
                      ) : (
                        ROUTE_ICON_MAP[route.label] || (
                          <RestaurantRoundedIcon fontSize="small" />
                        )
                      )}
                    </Box>
                    <Typography
                      sx={{
                        flex: 1,
                        fontWeight: isActive ? 700 : 500,
                        color: brand.charcoal,
                      }}
                    >
                      {route.label}
                    </Typography>
                    {isCart && cartItemCount > 0 && (
                      <Chip
                        size="small"
                        label={cartItemCount}
                        sx={{
                          bgcolor: brand.red,
                          color: "#fff",
                          fontWeight: 700,
                          height: 22,
                        }}
                      />
                    )}
                    <ChevronRightRoundedIcon sx={{ color: "rgba(0,0,0,0.3)" }} />
                  </Box>
                </motion.div>
              );
            })}
        </AnimatePresence>

        {isLogged && (
          <>
            <Divider sx={{ my: 1.5 }}>
              <Typography sx={{ fontSize: 11, letterSpacing: 2, color: "text.secondary" }}>
                ACCOUNT
              </Typography>
            </Divider>
            {[
              { label: "My Profile", path: "/customer/profile", icon: <PersonOutlineRoundedIcon fontSize="small" /> },
              { label: "My Orders", path: "/orders", icon: <ReceiptLongRoundedIcon fontSize="small" /> },
            ].map((item) => (
              <Box
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  px: 1.5,
                  py: 1.2,
                  mb: 0.6,
                  borderRadius: 2,
                  cursor: "pointer",
                  "&:hover": { background: "rgba(183,28,28,0.06)" },
                }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "rgba(183,28,28,0.08)",
                    color: brand.red,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography sx={{ fontWeight: 500, color: brand.charcoal }}>
                  {item.label}
                </Typography>
              </Box>
            ))}
          </>
        )}
      </Box>

      {isLogged && (
        <Box sx={{ p: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
            sx={{
              borderColor: brand.red,
              color: brand.red,
              borderRadius: 999,
              py: 1.2,
              fontWeight: 700,
              textTransform: "none",
              "&:hover": {
                borderColor: brand.redDeep,
                bgcolor: "rgba(183,28,28,0.06)",
              },
            }}
          >
            Logout
          </Button>
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: brand.gradientPrimary,
          backgroundSize: "200% 200%",
          animation: "pt-gradient-shift 18s ease infinite",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          boxShadow: scrolled
            ? "0 14px 40px rgba(122,14,14,0.45), 0 2px 10px rgba(0,0,0,0.15)"
            : "0 8px 32px rgba(183,28,28,0.25), 0 2px 8px rgba(0,0,0,0.1)",
          transition: "box-shadow .3s ease",
          "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: 2,
            background:
              "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
            backgroundSize: "200% 100%",
            animation: "pt-shimmer 4s linear infinite",
            opacity: 0.5,
            pointerEvents: "none",
          },
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            minHeight: { xs: scrolled ? 60 : 68, md: scrolled ? 64 : 80 },
            transition: "min-height .3s ease",
            px: { xs: 2, md: 4 },
          }}
        >
          {Brand}

          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {renderDesktopRoutes()}

              {isLogged && (
                <>
                  <Tooltip title="Account">
                    <IconButton
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                      sx={{
                        ml: 1,
                        p: 0.5,
                        "&:hover": { transform: "scale(1.05)" },
                        transition: "transform .2s",
                      }}
                      aria-label="Open account menu"
                    >
                      <Box
                        sx={{
                          p: "2px",
                          borderRadius: "50%",
                          background: brand.gradientAmber,
                          boxShadow: "0 6px 18px rgba(255,179,0,0.5)",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: brand.redDeep,
                            color: "#fff",
                            width: 38,
                            height: 38,
                            fontWeight: 800,
                            border: "2px solid rgba(255,255,255,0.9)",
                          }}
                        >
                          P
                        </Avatar>
                      </Box>
                    </IconButton>
                  </Tooltip>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    PaperProps={{
                      sx: {
                        mt: 1.5,
                        minWidth: 220,
                        borderRadius: 3,
                        overflow: "hidden",
                        background:
                          "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,248,240,0.95))",
                        backdropFilter: "blur(20px)",
                        border: "1px solid rgba(183,28,28,0.12)",
                        boxShadow: "0 20px 50px rgba(122,14,14,0.25)",
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => handleNavigation("/customer/profile")}
                      sx={{ py: 1.3, gap: 1 }}
                    >
                      <ListItemIcon sx={{ color: brand.red, minWidth: 32 }}>
                        <PersonOutlineRoundedIcon fontSize="small" />
                      </ListItemIcon>
                      My Profile
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleNavigation("/orders")}
                      sx={{ py: 1.3, gap: 1 }}
                    >
                      <ListItemIcon sx={{ color: brand.red, minWidth: 32 }}>
                        <ReceiptLongRoundedIcon fontSize="small" />
                      </ListItemIcon>
                      My Orders
                    </MenuItem>
                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem
                      onClick={handleLogout}
                      sx={{ py: 1.3, gap: 1, color: brand.red, fontWeight: 600 }}
                    >
                      <ListItemIcon sx={{ color: brand.red, minWidth: 32 }}>
                        <LogoutRoundedIcon fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Box>
          )}

          {isMobile && (
            <IconButton
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.25)",
                "&:hover": { background: "rgba(255,255,255,0.25)" },
              }}
            >
              <Badge
                badgeContent={cartItemCount}
                showZero={false}
                sx={{
                  "& .MuiBadge-badge": {
                    bgcolor: brand.amber,
                    color: brand.redDeep,
                    fontWeight: 800,
                  },
                }}
              >
                <MenuIcon sx={{ color: "#fff" }} />
              </Badge>
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 24,
            borderBottomLeftRadius: 24,
            overflow: "hidden",
            boxShadow: "-20px 0 60px rgba(122,14,14,0.25)",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default WebNavbar;
